// @flow
import React, {Suspense} from 'react';
import {ErrorReportBoundary} from '@homeaway/react-error-reporter';
import {compose} from 'redux';
import {connect} from 'react-redux';
import userActions from '../../actions/user';
import type {State as ReduxState} from '../../reducers';
import type {PayLoadType} from '../../actions/user';

const LEX = React.lazy(
    /* istanbul ignore next */ () =>
        import(/* webpackChunkName: "react-lex" */ '@homeaway/react-lex')
);

type DispatchProps = {
    setLoggedIn: (PayLoadType) => void
};

type StateProps = {
    fullLocale: string,
    siteName: string,
    brand: string
};

type OwnProps = {
    onClose: () => void,
    onSuccess: () => void
};

type Props = DispatchProps & OwnProps & StateProps;

export const LoginExperience = (props: Props) => {
    const handleSuccess = (options?: {publicUuid: string}) => {
        const {setLoggedIn, onSuccess} = props;
        if (onSuccess) {
            onSuccess();
        }
        if (options && options.publicUuid) {
            window.analyticsdatalayer.publicuuid = options.publicUuid;
        }
        setLoggedIn({isLoggedIn: true});
    };
    const loginProps = {
        ...props,
        locale: props.fullLocale,
        site: props.siteName,
        siteName: props.brand,
        handleLoginSuccess: handleSuccess,
        handleCloseModal: props.onClose
    };
    return (
        <Suspense fallback={null}>
            <ErrorReportBoundary name={'there was an error in react-lex'}>
                <LEX {...loginProps} />
            </ErrorReportBoundary>
        </Suspense>
    );
};
const mapStateToProps = ({
    system: {fullLocale, siteName, brand}
}: ReduxState) => {
    return {
        fullLocale,
        siteName,
        brand
    };
};
const mapDispatchToProps = {
    setLoggedIn: userActions.setLoggedIn
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(
    LoginExperience
);
